import { ElevenLabsVoiceId } from '../types/voice';

export const getVoiceSampleUrl = (voiceId: ElevenLabsVoiceId): string => {
  return `/audio/samples/${voiceId}.mp3`;
};
